require("stylesheets/tailwind.scss")
require('stylesheets/antd-custom.scss')
require('stylesheets/application.scss')